export const CONNECT_TO_A_PAGE = "CONNECT_TO_A_PAGE";
export const CHANGE_PAGE_ACTIONS = "CHANGE_PAGE_ACTIONS";
export const CHANGE_ABANDONED_CART_SETTINGS_FIELD =
  "CHANGE_ABANDONED_CART_SETTINGS_FIELD";
export const CHANGE_APP_STATUS = "CHANGE_APP_STATUS";
export const CHANGE_APP_STATUS_RESULT = "CHANGE_APP_STATUS_RESULT";
export const UPDATE_RESULT_FIELD = "UPDATE_RESULT_FIELD";
export const GET_LIST_REVIEW = "GET_LIST_REVIEW";
export const GET_LIST_REVIEW_RESULT = "GET_LIST_REVIEW_RESULT";
export const GET_DETAIL_REVIEW = "GET_DETAIL_REVIEW";
export const GET_DETAIL_REVIEW_RESULT = "GET_DETAIL_REVIEW_RESULT";
export const CHANGE_STATUS_REVIEW = "CHANGE_STATUS_REVIEW";
export const CHANGE_STATUS_REVIEW_RESULT = "CHANGE_STATUS_REVIEW_RESULT";
export const SEND_PRODUCT_REVIEW_COMMENT = "SEND_PRODUCT_REVIEW_COMMENT";
export const SEND_PRODUCT_REVIEW_COMMENT_RESULT =
  "SEND_PRODUCT_REVIEW_COMMENT_RESULT";
export const DELETE_REVIEW_COMMENT = "DELETE_REVIEW_COMMENT";
export const DELETE_REVIEW_COMMENT_RESULT = "DELETE_REVIEW_COMMENT_RESULT";
export const EDIT_REVIEW_COMMENT = "EDIT_REVIEW_COMMENT";
export const EDIT_REVIEW_COMMENT_RESULT = "EDIT_REVIEW_COMMENT_RESULT";
export const DELETE_REVIEW = "DELETE_REVIEW";
export const DELETE_REVIEW_RESULT = "DELETE_REVIEW_RESULT";
export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_RESULT = "GET_SETTINGS_RESULT";
export const UPDATE_SETTINGS_RESULT = "UPDATE_SETTINGS_RESULT";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const CHANGE_SETTINGS = "CHANGE_SETTINGS";
export const DELETE_MULTI_REVIEW = "DELETE_MULTI_REVIEW";
export const DELETE_MULTI_REVIEW_RESULT = "DELETE_MULTI_REVIEW_RESULT";
export const EXPORT_FILE_EXCEL = "EXPORT_FILE_EXCEL";
export const EXPORT_FILE_EXCEL_RESULT = "EXPORT_FILE_EXCEL_RESULT";
export const IMPORT_FILE_EXCEL = "IMPORT_FILE_EXCEL";
export const IMPORT_FILE_EXCEL_RESULT = "IMPORT_FILE_EXCEL_RESULT";
export const GET_COUNT_REVIEW = "GET_COUNT_REVIEW";
export const GET_COUNT_REVIEW_RESULT = "GET_COUNT_REVIEW_RESULT";
export const CHANGE_ADMIN_READ_AT = "CHANGE_ADMIN_READ_AT";
export const CHANGE_ADMIN_READ_AT_RESULT = "CHANGE_ADMIN_READ_AT_RESULT";
export const CHANGE_ACTIVE_FORM_REVIEW = "CHANGE_ACTIVE_FORM_REVIEW";
export const CHANGE_ACTIVE_FORM_REVIEW_COMMENT =
  "CHANGE_ACTIVE_FORM_REVIEW_COMMENT";
export const CHANGE_ACTIVE_FORM_REVIEW_RESULT =
  "CHANGE_ACTIVE_FORM_REVIEW_RESULT";
export const CHANGE_ACTIVE_FORM_REVIEW_COMMENT_RESULT =
  "CHANGE_ACTIVE_FORM_REVIEW_COMMENT_RESULT";
export const CHANGE_ACTIVE_FORM_REVIEW_ORDER =
  "CHANGE_ACTIVE_FORM_REVIEW_ORDER";
export const CHANGE_ACTIVE_FORM_REVIEW_ORDER_RESULT =
  "CHANGE_ACTIVE_FORM_REVIEW_ORDER_RESULT";
export const GET_STATUS_FORM_EMAIL_REVIEW = "GET_STATUS_FORM_EMAIL_REVIEW";
export const GET_STATUS_FORM_EMAIL_REVIEW_COMMENT =
  "GET_STATUS_FORM_EMAIL_REVIEW_COMMENT";
export const GET_STATUS_FORM_EMAIL_REVIEW_RESULT =
  "GET_STATUS_FORM_EMAIL_REVIEW_RESULT";
export const GET_STATUS_FORM_EMAIL_REVIEW_COMMENT_RESULT =
  "GET_STATUS_FORM_EMAIL_REVIEW_COMMENT_RESULT";
export const GET_STATUS_FORM_EMAIL_REVIEW_ORDER =
  "GET_STATUS_FORM_EMAIL_REVIEW_ORDER";
export const GET_STATUS_FORM_EMAIL_REVIEW_ORDER_RESULT =
  "GET_STATUS_FORM_EMAIL_REVIEW_ORDER_RESULT";
export const SEND_TEST_EMAIL = "SEND_TEST_EMAIL";
export const SEND_TEST_EMAIL_RESULT = "SEND_TEST_EMAIL_RESULT";
export const GET_CAMPAIGN_NAME = "GET_CAMPAIGN_NAME";
export const GET_SETTING_SHOP_INFO = "GET_SETTING_SHOP_INFO";
export const RESULT_GET_SETTING_SHOP_INFO = "RESULT_GET_SETTING_SHOP_INFO";
export const SAVE_CAMPAIGN = "SAVE_CAMPAIGN";
export const RESULT_SAVE_CAMPAIGN = "RESULT_SAVE_CAMPAIGN";
export const GET_FORM_EMAIL_REVIEW = "GET_FORM_EMAIL_REVIEW";
export const GET_FORM_EMAIL_REVIEW_RESULT = "GET_FORM_EMAIL_REVIEW_RESULT";
export const GET_FORM_EMAIL_REVIEW_COMMENT = "GET_FORM_EMAIL_REVIEW_COMMENT";
export const GET_FORM_EMAIL_REVIEW_ORDER = "GET_FORM_EMAIL_REVIEW_ORDER";
export const GET_FORM_EMAIL_REVIEW_ORDER_RESULT =
  "GET_FORM_EMAIL_REVIEW_ORDER_RESULT";
export const GET_FORM_EMAIL_REVIEW_COMMENT_RESULT =
  "GET_FORM_EMAIL_REVIEW_COMMENT_RESULT";
export const CHANGE_ON_LOAD_DATA = "CHANGE_ON_LOAD_DATA";
export const GET_SHOP_INFO = "GET_SHOP_INFO";
export const GET_SHOP_INFO_RESULT = "GET_SHOP_INFO_RESULT";
export const GET_STATISTIC_BAR = "GET_STATISTIC_BAR";
export const GET_STATISTIC_BAR_RESULT = "GET_STATISTIC_BAR_RESULT";
export const GET_LIST_NOTIFICATION = "GET_LIST_NOTIFICATION";
export const GET_LIST_NOTIFICATION_RESULT = "GET_LIST_NOTIFICATION_RESULT";
export const GET_NOTIFICATION_DETAIL = "GET_NOTIFICATION_DETAIL";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const UPDATE_NOTIFICATION_RESULT = "UPDATE_NOTIFICATION_RESULT";
export const GET_NOTIFICATION_DETAIL_RESULT = "GET_NOTIFICATION_DETAIL_RESULT";
export const GET_STATISTIC_RATING = "GET_STATISTIC_RATING";
export const GET_STATISTIC_RATING_RESULT = "GET_STATISTIC_RATING_RESULT";
export const GET_LIST_LOG_EMAIL = "GET_LIST_LOG_EMAIL";
export const GET_LIST_LOG_EMAIL_RESULT = "GET_LIST_LOG_EMAIL_RESULT";
export const GET_STATISTIC_COUNT_TOTAL = "GET_STATISTIC_COUNT_TOTAL";
export const GET_STATISTIC_COUNT_TOTAL_RESULT =
  "GET_STATISTIC_COUNT_TOTAL_RESULT";
export const GET_STATISTIC_EMAIL = "GET_STATISTIC_EMAIL";
export const GET_STATISTIC_EMAIL_RESULT = "GET_STATISTIC_EMAIL_RESULT";
export const RESET_IS_SAVE_CAMPAIN = "RESET_IS_SAVE_CAMPAIN";
export const RESET_SEND_TEST_EMAIL = "RESET_SEND_TEST_EMAIL";
export const GET_LIST_PRODUCT = "GET_LIST_PRODUCT";
export const GET_LIST_PRODUCT_RESULT = "GET_LIST_PRODUCT_RESULT";
export const GET_RATE_PRODUCT = "GET_RATE_PRODUCT";
export const GET_RATE_PRODUCT_RESULT = "GET_RATE_PRODUCT_RESULT";
export const GET_CONTENT_LOG_EMAIL = "GET_CONTENT_LOG_EMAIL";
export const GET_CONTENT_LOG_EMAIL_RESULT = "GET_CONTENT_LOG_EMAIL_RESULT";
export const CHANGE_STATUS_MENU = "CHANGE_STATUS_MENU";
export const GET_LIST_EMAIL_VERIFY = "GET_LIST_EMAIL_VERIFY";
export const GET_LIST_EMAIL_VERIFY_RESULT = "GET_LIST_EMAIL_VERIFY_RESULT";
export const GET_LIST_BLOG = "GET_LIST_BLOG";
export const GET_LIST_BLOG_RESULT = "GET_LIST_BLOG_RESULT";
export const GET_COUNT_TOTAL_PRODUCT = "GET_COUNT_TOTAL_PRODUCT";
export const GET_COUNT_TOTAL_PRODUCT_RESULT = "GET_COUNT_TOTAL_PRODUCT_RESULT";
export const GET_RANDOM_PRODUCT = "GET_RANDOM_PRODUCT";
export const GET_RANDOM_PRODUCT_RESULT = "GET_RANDOM_PRODUCT_RESULT";
export const CANCEL_SAVE = "CANCEL_SAVE";
export const HIDDEN_REVIEW = "HIDDEN_REVIEW";
export const HIDDEN_REVIEW_RESULT = "HIDDEN_REVIEW_RESULT";
export const UPDATE_RESULT_FIELD_POPUP_REVIEW =
  "UPDATE_RESULT_FIELD_POPUP_REVIEW";
export const CHANGE_STATUS_POPUP_REVIEW = "CHANGE_STATUS_POPUP_REVIEW";
export const CHANGE_STATUS_POPUP_REVIEW_RESULT =
  "CHANGE_STATUS_POPUP_REVIEW_RESULT";
export const GET_SETTINGS_POPUP_REVIEW = "GET_SETTINGS_POPUP_REVIEW";
export const GET_SETTINGS_POPUP_REVIEW_RESULT =
  "GET_SETTINGS_POPUP_REVIEW_RESULT";
export const SAVE_SETTINGS_POPUP_REVIEW = "SAVE_SETTINGS_POPUP_REVIEW";
export const SAVE_SETTINGS_POPUP_REVIEW_RESULT =
  "SAVE_SETTINGS_POPUP_REVIEW_RESULT";
export const SET_DEFAULT_POPUP_REVIEW_CHECKOUT =
  "SET_DEFAULT_POPUP_REVIEW_CHECKOUT";
export const SET_DEFAULT_POPUP_REVIEW_MANUALLY =
  "SET_DEFAULT_POPUP_REVIEW_MANUALLY";
export const SET_DEFAULT_POPUP_REVIEW_ORDER = "SET_DEFAULT_POPUP_REVIEW_ORDER";
export const GET_LIST_PRODUCT_SEARCH = "GET_LIST_PRODUCT_SEARCH";
export const GET_LIST_PRODUCT_SEARCH_RESULT = "GET_LIST_PRODUCT_SEARCH_RESULT";
export const CHANGE_STATUS_GOOGLE_SNIPPET = "CHANGE_STATUS_GOOGLE_SNIPPET";
export const CHANGE_STATUS_GOOGLE_SNIPPET_RESULT =
  "CHANGE_STATUS_GOOGLE_SNIPPET_RESULT";
export const UPDATE_RESULT_FIELD_SNIPPET = "UPDATE_RESULT_FIELD_SNIPPET";
export const GET_SETTINGS_GOOGLE_SNIPPET = "GET_SETTINGS_GOOGLE_SNIPPET";
export const GET_SETTINGS_GOOGLE_SNIPPET_RESULT =
  "GET_SETTINGS_GOOGLE_SNIPPET_RESULT";
export const CHANGE_SETTINGS_RATING_ICON = "CHANGE_SETTINGS_RATING_ICON";
export const CHANGE_STATUS_CUSTOMER_SAY = "CHANGE_STATUS_CUSTOMER_SAY";
export const CHANGE_STATUS_CUSTOMER_SAY_RESULT =
  "CHANGE_STATUS_CUSTOMER_SAY_RESULT";
export const GET_SETTINGS_CUSTOMER_SAY = "GET_SETTINGS_CUSTOMER_SAY";
export const GET_SETTINGS_CUSTOMER_SAY_RESULT =
  "GET_SETTINGS_CUSTOMER_SAY_RESULT";
export const GET_LIST_REVIEW_CUSTOMER_SAY = "GET_LIST_REVIEW_CUSTOMER_SAY";
export const GET_LIST_REVIEW_CUSTOMER_SAY_RESULT =
  "GET_LIST_REVIEW_CUSTOMER_SAY_RESULT";
export const SAVE_CUSTOMER_SAY_SETTINGS = "SAVE_CUSTOMER_SAY_SETTINGS";
export const SAVE_CUSTOMER_SAY_SETTINGS_RESULT =
  "SAVE_CUSTOMER_SAY_SETTINGS_RESULT";
export const GET_LIST_DETAIL_BY_HANDLES = "GET_LIST_DETAIL_BY_HANDLES";
export const GET_LIST_DETAIL_BY_HANDLES_RESULT =
  "GET_LIST_DETAIL_BY_HANDLES_RESULT";
export const CHANGE_SETTINGS_CUSTOMER_SAY = "CHANGE_SETTINGS_CUSTOMER_SAY";
export const UPDATE_THEME_STYLE_POPUP_REVIEW =
  "UPDATE_THEME_STYLE_POPUP_REVIEW";
export const RESET_CUSTOMER_SAY_SETTINGS = "RESET_CUSTOMER_SAY_SETTINGS";
export const RESET_CUSTOMER_SAY_SETTINGS_RESULT =
  "RESET_CUSTOMER_SAY_SETTINGS_RESULT";
export const UPGRADE_PALN_PACKAGE = "UPGRADE_PALN_PACKAGE";
export const GET_DATA_PLAN = "GET_DATA_PLAN";
export const GET_DATA_PLAN_RESULT = "GET_DATA_PLAN_RESULT";

export const GET_LIST_CUSTOMER_SAY_BY_ID = "GET_LIST_CUSTOMER_SAY_BY_ID";
export const GET_LIST_CUSTOMER_SAY_BY_ID_RESULT =
  "GET_LIST_CUSTOMER_SAY_BY_ID_RESULT";
